module.exports = __webpack_public_path__ + "static/media/steps.92e0138b.jpg";